module.exports = __webpack_public_path__ + "static/media/panji-2.a4b60f21.jpg";